export default __webpack_public_path__ + "static/media/term-condition.b1816fd7.svg";